// extracted by mini-css-extract-plugin
export default {"photoInput":"form-section-verification_photoInput__TI-M5","descriptionText":"form-section-verification_descriptionText__NGHJ1"};